import React from 'react';
import PropTypes from 'prop-types';
import {TextField as MUTextField} from '@mui/material';

const emailRex =
/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const EmailInput = (props) => {
  const [isValid, setValid] = React.useState(null);

  const parentOnChange = props.onChange;

  const onChange = (e) => {
    const value = e.target.value;
    if (emailRex.test(value)) {
      parentOnChange({valid: true, value});
      setValid(true);
    } else {
      parentOnChange({valid: false, value});
      if (isValid) {
        setValid(false);
      }
    }
  };
  const onBlur = (e) => {
    const value = e.target.value;
    if (emailRex.test(value)) {
      parentOnChange({valid: true, value});
      setValid(true);
    } else {
      parentOnChange({valid: false, value});
      setValid(false);
    }
  };


  return (
    <MUTextField
      onChange={onChange}
      onBlur={onBlur}
      label={props.label}
      placeholder={props.placeholdText}
      helperText={ isValid === false && props.formFeedback}
      disabled={props.disabled}
      type="email"
      variant="outlined"
      fullWidth
      inputRef={(input) => props.autoFocus && input && input.focus()}
    />

  );
};

EmailInput.propTypes = {
  value: PropTypes.string,
  placeholdText: PropTypes.string,
  formFeedback: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  autoFocus: PropTypes.bool,
};

export default React.memo(EmailInput);
